export enum EmailAddressType {
    AP,
    REC,
    PP,
    STMT,
    All
}
